import { CONTACT_TYPE, OrderDetails, OrderNote } from "@/types";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { OrderWorker } from "@/components/pages";
import { useApi } from "@/api";
import { useFields } from "@/hooks";

const OrderWorkerView = () => {
  const { order } = useParams<'order'>();

  const navigate = useNavigate();
  
  const { order: orderEntity, session, worker } = useApi();
  const [fetched, setFetched] = useState(false);
  const [details, setDetails] = useState<OrderDetails>();
  const [notes, setNotes] = useState<OrderNote[]>();
  const [sentToClient, setSentToClient] = useState(false);

  const getOrderDetails = async (value: string) => {
    await orderEntity.getDetailedOrderData(value);
    const n = await orderEntity.getNotes(value);
    setNotes(n);
  }
  
  const isAdmin = useMemo(() => session.user?.admin || false, [session.user]);

  const {
    updateFields,
    ...fields
  } = useFields();

  useEffect(() => {
    if (order && !fetched) {
      getOrderDetails(order);
      setFetched(true);
    }
  }, [order]);

  useEffect(() => {
    const { orderDetails } = orderEntity;

    if (orderDetails) {
      setDetails(orderDetails);
      updateFields();   
    }
  }, [order, orderEntity.orderDetails]);

  const handleNope = () => true;

  const handleUploadFiles = useCallback(async (serviceId: string, files: File[], isDraft: boolean, isOffered?: boolean) => {
      if (order) {
        if (isOffered) {
          await worker.uploadFileOffered(files, serviceId);
        } else {
        await worker.uploadPhotos(files, serviceId, isDraft);
        }
  
        return getOrderDetails(order);
      }
    }, [order]);

  const handleSendToClient = useCallback(async() => {
    if (order) {
      await orderEntity.sendToClient(order);
      setSentToClient(true);
    }
  }, [order]);

  const handleNopeAsync = async () => Promise.resolve();

  const handleGetFloorAsync = async () => {
    return 0;
  }

  const handleNavigateToAdmin = () => {
    navigate(`/order-view-backend/order=${order}`);
  }

  const handleNavigateToCustomer = () => {
    navigate(`/order-view/order=${order}`);
  }

  return (
      <>
        {details && <OrderWorker
      logoUrl={""} orderServiceId={""} 
      {...fields}
      isAdmin={isAdmin}
      contacts={details.contacts.map(o => {
        return {
          contactId: o.id,
          customerId: details.customerId || '',
          email: o.email,
          name: o.name,
          phone1: o.phone1,
          phone2: o.phone2 || '',
          sendInvoice: false,
          type: o.type || CONTACT_TYPE.VENDOR
        };
      }) || []}
      notes={notes || []}
      onAddFurnitures={handleNope}
      onAddNote={handleNope}
      onAskToChangeWorker={handleNope}
      onChangePackage={handleNope}
      onConfirmFiles={handleNopeAsync}
      onChooseDraftFiles={handleNopeAsync}
      onDeleteFiles={handleNopeAsync}
      onDownloadFiles={handleNope}
      onGetFloorArea={handleGetFloorAsync}
      onNavigateToAdmin={handleNavigateToAdmin}
      onNavigateToCustomer={handleNavigateToCustomer}
      onRecordFloorArea={handleNopeAsync}
      onSendToClient={handleSendToClient}
      onShareOrder={handleNope}
      coordinator={null}
      onTakeRole={handleNope}
      onUploadFiles={handleUploadFiles}
      onChangeRole={handleNope}
      offeredServices={details.offeredServices || []}
      orderDetails={details}
      sentToClient={sentToClient}
      services={details.services || []}
      owner={`${session.user?.firstName} ${session.user?.lastName}`}        /> }
      </>
    );
  }
  
  export default OrderWorkerView;